module.exports = {
	_init: function(settings) {
		this.$el.carousel({
			interval: settings.interval ? settings.interval : false,
		});
	},
}